<script setup>
import { inject } from 'vue'

const props = defineProps({
  href: { type: String, default: null },
  target: { type: String, default: null },
  disabled: { type: Boolean, default: false },
  as: { type: String, default: null },
})

const close = inject('uiMenuClose', () => {})

function onClick(e) {
  if (props.disabled) {
    e.preventDefault()
    return
  }
  close()
}
</script>

<template>
  <component
    :is="as || (href ? 'a' : 'button')"
    :href="disabled ? null : href"
    :target="target"
    :type="!href && !as ? 'button' : null"
    :aria-disabled="disabled || null"
    role="menuitem"
    class="block w-full text-left px-4 py-2 text-sm transition-colors"
    :class="disabled
      ? 'text-[color:var(--muted)] opacity-50 cursor-not-allowed'
      : 'text-[color:var(--ink)] hover:bg-[color:var(--surfaceAlt)]'"
    @click="onClick"
  >
    <slot />
  </component>
</template>
